export default __webpack_public_path__ + "static/media/Gift Annual Subscription.47b2591d.png";